export const isEqualVal = <T, >(obj: T, oth: T, props: Array<keyof T>) => {
  let flag = true;

  for (let i = 0; i < props.length; i++) {
    if (typeof obj[props[i]] !== typeof oth[props[i]]) {
      flag = false;
      break;
    }
    let objVal = obj[props[i]]
    let othVal = oth[props[i]]

    if (typeof obj[props[i]] === 'string') {
      objVal = (objVal as string).trim() as T[keyof T]
      othVal = (othVal as string).trim() as T[keyof T]
    }

    if (objVal !== othVal) {
      flag = false;
      break;
    }
  }

  return flag;
}